import {Button, Group, Loader} from '@mantine/core';
import {useMachine} from '@xstate/react';
import React from 'react';

import {
  FullScreenFlow,
  FullScreenFlowContent,
  FullScreenFlowFooter,
  FullScreenFlowHeader,
} from 'antibodies/nested-data-creation/full-screen/FullScreenFlowLayout';
import ProteinCreationFlowMachine from 'antibodies/nested-data-creation/full-screen/ProteinCreationFlowMachine';
import ProteinCreationTable from 'antibodies/nested-data-creation/full-screen/ProteinCreationTable';
import * as FullScreenActions from 'nav/full-screen/FullScreenActions';

function ProteinCreationFlowPage(): JSX.Element {
  const [state, send] = useMachine(ProteinCreationFlowMachine, {input: {}});
  const {selectedSchemaName} = state.context.creationSettings;

  return (
    <FullScreenFlow>
      <FullScreenFlowHeader
        title="Create proteins"
        subtitle={selectedSchemaName}
        onClose={() => {
          FullScreenActions.hideScreenForRouting();
        }}
      />
      <FullScreenFlowContent>
        {state.matches('initializing') ? (
          <Loader />
        ) : (
          <ProteinCreationTable creationSettings={state.context.creationSettings} />
        )}
      </FullScreenFlowContent>
      <FullScreenFlowFooter>
        <Group position="right">
          <Button
            onClick={() => {
              send({type: 'next'});
            }}
          >
            Next
          </Button>
        </Group>
      </FullScreenFlowFooter>
    </FullScreenFlow>
  );
}

export default ProteinCreationFlowPage;
